export { default } from './EventCard'
